import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ImageViewerDialogData {
  /** Direct image URL — Firebase download URL for captured photos, or a reference photo URL. */
  url: string;
  /** Optional caption, e.g. the finding name a photo belongs to. */
  caption?: string;
}

/**
 * Full-size view of a single inspection photo. Deliberately trivial: thumbnails are
 * too small to judge pest damage on, and this opens over whatever is already on screen
 * without disturbing the form beneath it — including from the finding detail modal,
 * which is itself a dialog.
 */
@Component({
  selector: 'app-image-viewer-dialog',
  templateUrl: './image-viewer-dialog.component.html',
  standalone: false
})
export class ImageViewerDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ImageViewerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ImageViewerDialogData
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
